import { render, staticRenderFns } from "./Webshop.vue?vue&type=template&id=158cce60&scoped=true&"
import script from "./Webshop.vue?vue&type=script&lang=js&"
export * from "./Webshop.vue?vue&type=script&lang=js&"
import style0 from "./Webshop.vue?vue&type=style&index=0&id=158cce60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158cce60",
  null
  
)

export default component.exports